import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bid-currency d-flex align-center" }

import { computed } from 'vue';
import { useStore } from 'vuex';
import { IAsset } from '@/types/store';

// #constants

export default /*@__PURE__*/_defineComponent({
  __name: 'BidViewCurrency',
  setup(__props) {

const { getters } = useStore();

// #computed
const getAsset = computed<IAsset>(() => {
  return getters['getAsset'];
});
const getCurrency = computed<string>(() => {
  const { currency = '' } = getAsset.value ?? {};
  return currency;
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_icon, {
      color: "#BDBDBD",
      class: "mr-2"
    }, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createTextVNode("mdi-credit-card-outline", -1)
      ]))]),
      _: 1
    }),
    _createTextVNode(" Payment Currency: " + _toDisplayString(getCurrency.value), 1)
  ]))
}
}

})